import dayjs from "dayjs";

export const isBelow14 = (val: string) => {
  const date = dayjs();
  const year = date.year();
  const age = year - Number(val);

  return age < 14;
};
